import type { Item, ArticleButtonType } from '../../types';

export const isArticleButton = (item: Item): item is ArticleButtonType => {
	return !!(item && item.__typename === 'Article_Button');
};
